import { useMatch } from 'react-router'

// Derive the current org id or slug from the URL, so the org data provider can
// be mounted above the router (covering the sidebar and the org pages alike).
// A slug that doesn't match any org simply yields an empty subscription.
export function useOrgRouteParams(): { orgId?: string; slug?: string } {
  const orgMatch = useMatch('/orgs/:orgId/*')
  const slugMatch = useMatch('/:slug/*')
  // Anything else under /orgs is not an org id, and sending it to Hasura would
  // fail with a uuid syntax error shown raw on screen (#101). Ignored, it falls
  // back to the "orgs" slug, which resolves no org: the org route renders its
  // 404. Guard taken from upstream 68e37a63, without its /orgs route.
  const orgId = uuidRegex.test(orgMatch?.params.orgId ?? '')
    ? orgMatch?.params.orgId
    : undefined
  const slug = orgId ? undefined : slugMatch?.params.slug ?? undefined
  return { orgId, slug }
}

const uuidRegex =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i
